import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Pill, SectionStamp } from '../components/Atoms';
import TopBar from '../components/TopBar';
import TabBar from '../components/TabBar';
import WhatsAppFab from '../components/WhatsAppFab';
import { fonts } from '../theme';

export default function About({ t }) {
  const navigate = useNavigate();

  return (
    <div style={{
      width: '100%', height: '100%', position: 'relative',
      overflow: 'hidden', background: t.paper, color: t.ink,
    }}>
      <TopBar t={t} dark={false} title="About" />

      <div style={{
        position: 'absolute', top: 50, left: 0, right: 0, bottom: 0,
        overflowY: 'auto', padding: '0 22px 100px',
      }}>
        <SectionStamp n="00" label="Practitioner" t={t} />
        <h1 style={{
          fontFamily: fonts.serif, fontWeight: 300,
          fontSize: 44, lineHeight: 0.95, letterSpacing: '-0.035em',
          margin: '14px 0 18px',
        }}>
          <span>Dr. Moksha</span><br/>
          <span style={{ fontStyle: 'italic' }}>Patel, </span>
          <span style={{
            color: t.mintDeep, fontFamily: fonts.mono, fontSize: 14,
            letterSpacing: '0.04em', verticalAlign: 'middle',
          }}>(PT)</span>
        </h1>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 14, marginTop: 6 }}>
          <div style={{
            position: 'relative', height: 320, borderRadius: 14, overflow: 'hidden', background: t.ink,
          }}>
            <div style={{
              position: 'absolute', inset: 0,
              background: `radial-gradient(60% 70% at 50% 30%, ${t.tint}cc, ${t.ink})`,
            }}/>
            <img src={`${process.env.PUBLIC_URL}/assets/hero.webp`} alt="Dr. Moksha Patel" style={{
              position: 'absolute', inset: 0, width: '100%', height: '100%',
              objectFit: 'contain', objectPosition: 'center bottom',
            }}/>
            <div style={{
              position: 'absolute', left: 14, top: 14, color: t.paper,
              fontFamily: fonts.mono, fontSize: 9.5, letterSpacing: '0.18em', textTransform: 'uppercase',
              opacity: 0.7,
            }}>Vadodara · Est. 2021</div>
            <div style={{
              position: 'absolute', left: 14, bottom: 14, color: t.paper,
              fontFamily: fonts.serif, fontSize: 14, fontStyle: 'italic',
            }}>&ldquo;Movement is medicine.&rdquo;</div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div style={{ borderTop: `0.5px solid ${t.hair}`, paddingTop: 8 }}>
              <div style={{
                fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                letterSpacing: '0.16em', textTransform: 'uppercase',
              }}>License</div>
              <div style={{ fontFamily: fonts.serif, fontSize: 18, marginTop: 2 }}>GPC-21250</div>
            </div>
            <div style={{ borderTop: `0.5px solid ${t.hair}`, paddingTop: 8 }}>
              <div style={{
                fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                letterSpacing: '0.16em', textTransform: 'uppercase',
              }}>Education</div>
              <div style={{ fontFamily: fonts.serif, fontSize: 18, marginTop: 2 }}>KPGU</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 32 }}>
          <SectionStamp n="01" label="Introduction" t={t} />
          <p style={{
            fontFamily: fonts.serif, fontSize: 18, lineHeight: 1.4, fontWeight: 400,
            letterSpacing: '-0.01em', margin: '12px 0 0', color: t.ink,
          }}>
            <span style={{
              fontFamily: fonts.serif, fontSize: 44, fontStyle: 'italic',
              float: 'left', lineHeight: 0.85, marginRight: 6, marginTop: 4, color: t.mintDeep,
            }}>I</span>
            <span> am a dedicated physiotherapist with a passion for helping patients regain mobility, strength, and confidence in their daily lives &mdash; through care that listens before it prescribes.</span>
          </p>
        </div>

        <div style={{ marginTop: 28 }}>
          <SectionStamp n="02" label="Professional statement" t={t} />
          <p style={{
            fontFamily: fonts.sans, fontSize: 13.5, lineHeight: 1.55,
            margin: '12px 0 0', color: t.ink,
          }}>
            I specialise in orthopaedic, neurological, paediatric, geriatric and post-operative care. Each plan is built around the patient &mdash; not the protocol &mdash; and revised every session as you progress.
          </p>
        </div>

        <div style={{ marginTop: 28 }}>
          <SectionStamp n="03" label="Method" t={t} />
          <div style={{ marginTop: 14 }}>
            {[
              { k: 'Listen', v: 'A 30-minute first consult — history, lifestyle, goals.' },
              { k: 'Assess', v: 'Range, posture, gait, strength. Hands-on, no shortcuts.' },
              { k: 'Plan', v: 'A weekly programme tied to a measurable outcome.' },
              { k: 'Refine', v: 'We revisit and adjust at every session.' },
            ].map((row, i) => (
              <div key={i} style={{
                display: 'grid', gridTemplateColumns: '60px 1fr',
                padding: '14px 0', borderTop: `0.5px solid ${t.hair}`, gap: 14,
              }}>
                <div style={{
                  fontFamily: fonts.serif, fontSize: 18, fontStyle: 'italic',
                  color: t.mintDeep,
                }}>{String(i + 1).padStart(2, '0')}</div>
                <div>
                  <div style={{ fontFamily: fonts.sans, fontSize: 13, fontWeight: 600 }}>{row.k}</div>
                  <div style={{
                    fontFamily: fonts.sans, fontSize: 12, color: t.muted,
                    marginTop: 3, lineHeight: 1.45,
                  }}>{row.v}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 28 }}>
          <Pill t={t} fill={t.ink} ink={t.paper} icon="calendar" onClick={() => navigate('/book')}>
            Book a first consult
          </Pill>
        </div>
      </div>

      <WhatsAppFab bottom={100}/>
      <TabBar t={t}/>
    </div>
  );
}
